export default "__VITE_ASSET__CUZQqz44__"